export default "__VITE_ASSET__a340c419__"